<template>
    <v-dialog 
        persistent
        width="500"
        overlay-color="rgb(81, 69, 133)"
        overlay-opacity="0.98"
        v-model="dialog"
        transition="wildcard-transition"
        >
        <v-img 
            :src="require('@/assets/img/gamifications/hand.png')"
            class="dialog-icon"
            height="80"
            width="80"
            />
        <v-card class="d-flex flex-column justify-center align-center border-radius-1 pistas-content">
            <div class="chip-tag_corner-left">
                <v-img
                width="100"
                height="42"
                alt="pistas imagen de modal"
                class="chip-tag_label label_left"
                :src="require('@/assets/img/gamifications/tag-tienes.png')"
                />
                <!-- <v-img :src="beecoinImg" width="36" height="36" alt="pistas imagen de modal" /> -->
                <div class="chip-tag  border-radius-1 pl-2 pr-3">
                    <span class="font-weight-black">{{ count_beecoins }}</span>
                </div>
            </div>
                <!-- <div>
                    <span class="white--text mt-n6 text-capitalize">{{ msg_beecoins }}</span>
                </div> -->
            <!-- <div class="d-flex flex-column justify-center align-center">
                <img :src="varitaImg" alt="pistas imagen de modal" />
            </div> -->
            <div class="pt-6 pb-2">
                <span 
                    class="text-h6 white--text text-center font-weight-lighter"
                    v-html="$t('bookReading.wildcard_50_50')">
                </span>
            </div>
            <div class="chip-tag border-radius-1 pl-2 pr-3 my-4">
                <v-img
                    width="68"
                    height="48"
                    alt="pistas imagen de modal"
                    class="chip-tag_label label_center"
                    :src="require('@/assets/img/gamifications/tag-precio.png')"
                        />
                <v-img :src="beecoinImg" width="36" height="36" alt="pistas imagen de modal" />
                <span class="font-weight-black">{{ wildcard_price }}</span>
            </div>
            
            <div class="px-5 mx-5">
                <span class="white--text text-body-1">
                    {{ $t('bookReading.wildcard_buy_msg') }}
                </span>
            </div>
            <v-card-actions class="d-flex justify-center align-center ma-4 w-100">
                <v-btn color="white" class="px-5 py-5 text-transform-none border-radius-1 font-weight-bolder" outlined @click="close">
                    {{ $t('go_back') }}
                </v-btn>
                <v-btn color="white" class="px-5 py-5 text--primary text-transform-none border-radius-1 font-weight-bolder" @click="confirmAction">
                    {{ $t('bookReading.buy_wildcard') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
        count_beecoins: { type: [String, Number], default: 0 },
        wildcard_price: { type: [String, Number], default: 0 },
    },
    data() {
        return {
            varitaImg: require('@/assets/img/gamifications/desafios-varita.svg'),
            beecoinImg: require('@/assets/img/icons/beecoins.png'),
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        confirmAction() {
            this.$emit('confirm')
            this.$root.$emit('closeWildcard', this.closeDialogOptions)
            // send event to close dialog
            this.$root.$emit('dialogOptions', this.closeDialogOptions)
            console.log('cerrar comodin')
        },
    },
    computed: {
        msg_beecoins() {
            return `${this.$t('bookReading.have')} ${this.count_beecoins} ${this.$t('beecoins')}`
        },
    },
}
</script>
<style lang="scss">
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
/* .pistas-content {
    border-radius: 26px;
    background: linear-gradient(180deg, #6f5fa4 0%, #261c48 100%);
} */
.items-unset {
    align-items: unset !important;
}
.chip-tag{
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #fff;
    color: #fff;
    display: flex;
    justify-content: center;
    min-height: 38px;
    overflow: visible !important;
    position:relative;
    &_label{
        position: absolute;
        top: -28px;
    }
    .label{
        &_left{
            left: 0;
            z-index: 10;
        }
        &_center{
            left: 50%;
            transform: translateX(-50%);
        }
    }
    &_corner-left{
        position: absolute;
        left: 1em;
        top: 3em;
        min-width: 100px;
        text-align: start;
    }
}
.label_left{
    left: 0;
    top: -22px;
    z-index: 1;
}
</style>
